import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import { INDUSTRIES } from "@/data/content";

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} />;
};

export default function Industries() {
  return (
    <>
      <SEO title="Industries" description="Enterprise database consulting for fintech, healthcare, logistics, manufacturing, retail, e-commerce, SaaS, startups and global enterprises." />

      <section className="bg-[var(--dm-navy)] text-white">
        <div className="dm-container py-24 lg:py-32">
          <div className="dm-overline text-[var(--dm-emerald)]">Industries</div>
          <h1 className="font-serif text-5xl sm:text-6xl mt-6 max-w-4xl leading-[1.05]">Specialist database consulting for the industries that can't afford downtime.</h1>
        </div>
      </section>

      <section className="bg-white">
        <div className="dm-container dm-section grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--dm-border)]">
          {INDUSTRIES.map((i) => (
            <Link key={i.slug} to={`/industries/${i.slug}`} data-testid={`industry-${i.slug}`} className="group bg-white p-10 hover:bg-[var(--dm-surface)] transition-colors">
              <div className="w-10 h-10 grid place-items-center bg-[var(--dm-navy)] text-white">
                <Icon name={i.icon} className="w-5 h-5" />
              </div>
              <div className="font-serif text-2xl text-[var(--dm-navy)] mt-6">{i.name}</div>
              <div className="text-sm text-[var(--dm-muted)] mt-3 leading-relaxed">{i.summary}</div>
              <div className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[var(--dm-emerald)]">
                Explore <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
